import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Table, { TableBody } from 'material-ui/Table';
import Paper from 'material-ui/Paper';

import { acceptedColumns } from './columns';
import MaterialHead from './MaterialHead';
import MaterialRow from './MaterialRow';
import TableToolbar from '../TableToolbar';
import { mhz2label, getLengthUnit } from '../../../lib/unitConversions';
import { extractMhzs } from '../../../lib/material';
import { materialPropType } from '../../../lib/shapes';

const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit * 3,
    width: '100%',
    overflowX: 'auto',
  },
  toolbar: {
    width: '100%',
    overflowX: 'hidden'
  },
  body: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  }
})

export const MaterialsTable = (props) => {
  const {
    classes,
    columns,
    materials,
    header,
    onRowClick,
    selectRender,
    shiftHeadCols,
    lengthUnit: lengthUnitName
  } = props;
  const mhzs = extractMhzs(materials, ['dk', 'df']);
  const frequencies = mhzs.map(mhz2label);
  const unit = getLengthUnit(lengthUnitName);

  return (
    <Paper className={classes.root}>
      <Paper className={classes.toolbar}>
        <TableToolbar selected>{header}</TableToolbar>
      </Paper>
      <Paper className={classes.body}>
        <Table className={classes.table}>
          <MaterialHead
            columns={columns}
            frequencies={frequencies}
            shiftHeadCols={shiftHeadCols || 0}
            lengthUnit={unit}
          />
          <TableBody>
            {materials.map(material => (
              <MaterialRow
                columns={columns}
                key={material.id}
                mhzs={mhzs}
                material={material}
                handleClick={onRowClick}
                selectRender={selectRender}
                lengthUnit={unit}
              />
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Paper>
  );
}

MaterialsTable.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    toolbar: PropTypes.string,
    body: PropTypes.string,
    table: PropTypes.string
  }).isRequired,
  columns: PropTypes.arrayOf(PropTypes.oneOf(acceptedColumns)),
  materials: PropTypes.arrayOf(PropTypes.shape(materialPropType)),
  header: PropTypes.string.isRequired,
  shiftHeadCols: PropTypes.number,
  onRowClick: PropTypes.func,
  selectRender: PropTypes.func,

  /* mapStateToProps */
  lengthUnit: PropTypes.string.isRequired,
}

MaterialsTable.defaultProps = {
  materials: [],
  columns: undefined,
  onRowClick: undefined,
  selectRender: undefined,
  shiftHeadCols: undefined
}

export default  withStyles(styles)(MaterialsTable);



// WEBPACK FOOTER //
// ./src/components/common/MaterialsTable/MaterialsTable.js